import { useThemeColor } from "@/hooks/useThemeColor";
import * as React from "react";
import { View } from "react-native";
import { useTranslation } from "react-i18next";
import { MaskIcon } from "./MaskIcon";

type Props = {
  size?: number;
  style?: any;
};

export const AnonymousAvatar: React.FC<Props> = ({ size = 40, style }) => {
  const bg = useThemeColor({}, "icon");
  const fg = useThemeColor({}, "background");
  const { t } = useTranslation();
  return (
    <View
      testID="anonymous-avatar"
      accessibilityLabel={t("ANONYMOUS_USER")}
      style={[
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: bg,
          alignItems: "center",
          justifyContent: "center",
        },
        style,
      ]}
    >
      <MaskIcon size={Math.round(size * 0.55)} color={fg} />
    </View>
  );
};

export default AnonymousAvatar;
